import Pusher from 'pusher-js'

// Mêmes identifiants que le mobile — canaux PUBLICS (pas d'auth requise).
// Le backend diffuse via PusherService :
//   chat-{conversationId}  → 'message.sent', 'messages.read'
//   user-{userId}          → 'conversation-updated'
const PUSHER_KEY     = import.meta.env.VITE_PUSHER_KEY     || 'fc09a157d4aaf4747093'
const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_CLUSTER || 'mt1'

let _instance = null

function getPusher() {
  if (!_instance) {
    _instance = new Pusher(PUSHER_KEY, {
      cluster:  PUSHER_CLUSTER,
      forceTLS: false, // aligné sur PUSHER_USE_TLS=false côté backend
    })
  }
  return _instance
}

/**
 * S'abonne au canal d'une conversation et écoute les nouveaux messages / accusés de lecture.
 * @returns {() => void} fonction de nettoyage (unbind + unsubscribe)
 */
export function bindChat(conversationId, { onMessage, onRead, onTyping } = {}) {
  const pusher  = getPusher()
  const name    = `chat-${conversationId}`
  const channel = pusher.subscribe(name)
  if (onMessage) channel.bind('message.sent', onMessage)
  if (onRead)    channel.bind('messages.read', onRead)
  if (onTyping)  channel.bind('typing', onTyping)

  return () => {
    if (onMessage) channel.unbind('message.sent', onMessage)
    if (onRead)    channel.unbind('messages.read', onRead)
    if (onTyping)  channel.unbind('typing', onTyping)
    pusher.unsubscribe(name)
  }
}

/**
 * S'abonne au canal personnel de l'utilisateur (mises à jour de la liste de conversations).
 * @returns {() => void} fonction de nettoyage
 */
export function bindUserChannel(userId, { onConversationUpdated } = {}) {
  const pusher  = getPusher()
  const name    = `user-${userId}`
  const channel = pusher.subscribe(name)
  if (onConversationUpdated) channel.bind('conversation-updated', onConversationUpdated)

  // Canal partagé/persistant (plusieurs composants peuvent s'y abonner) :
  // on retire UNIQUEMENT notre handler, sans désabonner le canal — sinon le
  // démontage d'un composant couperait les events pour les autres.
  return () => {
    if (onConversationUpdated) channel.unbind('conversation-updated', onConversationUpdated)
  }
}
